"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Icons_1 = require("./Icons");
const colors_1 = require("../styles/colors");
const typography_1 = require("../styles/typography");
const Alert = ({ message, type, style }) => {
    let messageStyle = Object.assign({}, typography_1.small, typography_1.text, { width: '100%', height: 36, border: '2px solid', borderRadius: 4, display: 'flex', alignItems: 'center' }, style);
    if (type === 'info') {
        messageStyle = Object.assign({}, messageStyle, { borderColor: colors_1.turquoise, backgroundColor: colors_1.palefoam });
    }
    if (type === 'warn') {
        messageStyle = Object.assign({}, messageStyle, { borderColor: colors_1.yellow, backgroundColor: colors_1.paleyellow });
    }
    if (type === 'error') {
        messageStyle = Object.assign({}, messageStyle, { borderColor: colors_1.red, backgroundColor: colors_1.palered });
    }
    const getAlertIcon = () => {
        switch (type) {
            case 'info':
                return React.createElement(Icons_1.AlertInfoIcon, { fill: colors_1.turquoise, style: { marginLeft: 8, marginRight: 8 } });
            case 'warn':
                return React.createElement(Icons_1.AlertWarnIcon, { fill: colors_1.yellow, style: { marginLeft: 8, marginRight: 8 } });
            case 'error':
                return React.createElement(Icons_1.AlertErrorIcon, { fill: colors_1.red, style: { marginLeft: 8, marginRight: 8 } });
            default:
                return null;
        }
    };
    return (React.createElement("div", { style: messageStyle },
        getAlertIcon(),
        message));
};
exports.default = Alert;
